<template>
      <div class="carousel slide carousel-fade" id="carousel-756730" data-ride="carousel" data-pause=false data-interval=8000>
                    <div class="carousel-inner">
                        <div class="carousel-caption-main centered text-center">
                            <h4>
                                (Bree-gah-day-row)
                            </h4>
                            <p>
                                Artisanal Brazilian Chocolate Truffle Candy
                            </p>
                        </div>
                       
                        <div v-if="items && items[0]" id="caro-back1" class="carousel-item active" data-type="background" data-speed="8" :style="{background: 'url(' + items[0].slide_image.url + ') no-repeat 50% 0', 'background-size': '150%'}">

                            <div class="carousel-caption">

                            </div>
                        </div>
                        
                        <div v-if="items && items[1]" id="caro-back2" class="carousel-item" data-type="background" data-speed="8" :style="{background: 'url(' + items[1].slide_image.url + ') no-repeat 50% 0', 'background-size': '150%'}">

                            <div class="carousel-caption">

                            </div>
                        </div>
                        <div v-if="items && items[2]" id="caro-back3" class="carousel-item" data-type="background" data-speed="8" :style="{background: 'url(' + items[2].slide_image.url + ') no-repeat 50% 0', 'background-size': '150%'}">

                            <div class="carousel-caption">

                            </div>
                        </div>

                        <div v-if="items && items[3]" id="caro-back4" class="carousel-item" data-type="background" data-speed="8" :style="{background: 'url(' + items[3].slide_image.url + ') no-repeat 50% 0', 'background-size': '150%'}">

                            <div class="carousel-caption">

                            </div>
                        </div>


                    </div>
                </div>
</template>
<script>
import $ from 'jquery'
import 'bootstrap/js/dist/carousel'

 export default {
    name: 'Carousel',
    props: ['items']  ,
    data() {
        return {
            ind1: 0
        }
        
    },
    updated(){
         var $window = $(window);
       $('div[data-type="background"]').each(function(){
            // declare the variable to affect the defined data-type
            var $scroll = $(this);     
            $(window).scroll(function() {
                // HTML5 proves useful for helping with creating JS functions!
                // also, negative value because we're scrolling upwards                             
                var yPos = -($window.scrollTop() / $scroll.data('speed')); 
                
                // background position
                var coords = '50% '+ yPos + 'px';
        
                // move the background
                $scroll.css({ backgroundPosition: coords });    
            }); // end window scroll
        }); 
    },
    mounted() {
       
    }
 }
 
</script>
<style lang='scss'>
.carousel {
    margin-top: 45px;
}
.carousel-caption-main {
    position: absolute;
    z-index: 20;
    width: 100%;
    top: 40%;
    transform: translateY(-50%);
    h4 {
        font-family: "lust-script",sans-serif;
        font-size: 3em;
        @media (max-width: 500px){
            font-size: 2em;
        }
        color: #Fff;
        text-shadow: 3px 3px 7px #000;
    }
    p{
        font-size: 1.8em;
        color: #Fff;
        text-shadow: 2px 2px 5px #444;
    }
}
.carousel img {
    width: 100%;
    height: auto;
    max-height: 680px;
}

/* Carousel fade */
.carousel-fade .carousel-inner {
    .item {
        opacity: 0;
        -webkit-transition-property: opacity;
        -moz-transition-property: opacity;
        -o-transition-property: opacity;
        transition-property: opacity;
    }
    .item,
        .active.left,
        .active.right {
            opacity: 0;
        }

        .active,
        .next.left,
        .prev.right {
            opacity: 1;
        }

        .next,
        .prev,
        .active.left,
        .active.right {
            left: 0;
            transform: translate3d(0, 0, 0);
        }
    
  }

  
  .carousel-fade .carousel-control {
    z-index: 2;
  }


.item {
    height: 75vh;
}



@media only screen and (min-width: 800px) and (max-width:986px){
    #caro-back1,#caro-back2,#caro-back3,#caro-back4,#flavor-back1, #event-back1,#package-back1 {
        height: 380px;
    }

}
@media only screen and (min-width: 1025px){
    #caro-back1,#caro-back2,#caro-back3,#caro-back4,#flavor-back1, #event-back1,#package-back1 {
        height: 880px;
    }
}
@media only screen and (min-width: 800px) and (max-width: 1024px){
    #caro-back1,#caro-back2,#caro-back3,#caro-back4,#flavor-back1, #event-back1,#package-back1 {
        height: 700px;
    }
}
/* Smaller than standard 960 (devices and browsers) */
@media only screen and (max-width: 959px) {
    #caro-back1,#caro-back2,#caro-back3,#caro-back4,#flavor-back1,#event-back1,#package-back1 {
        height: 400px;
    }
}

/* Tablet Portrait size to standard 960 (devices and browsers) */
@media only screen and (min-width: 768px) and (max-width: 959px) {
     .carousel-caption-main {
        position: absolute;
        z-index: 20;
    }
    .carousel-caption-main h4 {
    font-family: "lust-script",sans-serif;
    font-size: 2em;
    color: #Fff;
    text-shadow: 3px 3px 7px #000;
    }
}
.carousel-caption-main {
        position: absolute;
        
        z-index: 20;
        
    }
 .carousel-caption-main h4 {
    font-family: "lust-script",sans-serif;
    
    color: #Fff;
    text-shadow: 3px 3px 7px #000;
}

    #caro-back1 {
       
        width:100%;
        
        
        background-size: cover;
    }
    #flavor-back1 {
       
        width:100%;
        
        
        background-size: 110%;
    }
     #package-back1 {
        
        width:100%;
        
        
        background-size: 110%;
    }
      #event-back1 {
        
        width:100%;
        
        
        background-size: 110%;
    }
    #caro-back2 {
        
        width:100%;
        background-size:cover;
        
        /*background-size: 110%;*/
    }
    #caro-back3 {
        
        width:100%;
       
        background-size: cover;
    }

    #caro-back4 {
       
        width:100%;
       
        background-size: cover;
    }

    @media only screen and (max-width: 740px){
        #caro-back1, #caro-back2, #caro-back3 {
            background-size: 120%;
        }
    }
    @media only screen and (min-width: 741px) and (max-width: 1024px){
        #caro-back1, #caro-back2, #caro-back3 {
            background-size: 150%;
        }
    }
</style>